export const difficultiesConfig = {
  1: {
    name: "Easy",
    shift: 2,
    singlePathConstraints: { minLine: 6, maxOccurrences: 1, minOccurrences: 1 },
    areBlockadesRestrictedToChaos: true,
    blockadesInSinglePathChance: 1,
    blockadeStartBias: 0,
    nonAdjacentBlockadesBias: 0.85,
    guaranteeSafeStartLines: 3,
    towerVerticalShift: 0,
  },
  2: {
    name: "Medium",
    shift: 2,
    singlePathConstraints: { minLine: 4, maxOccurrences: 2, minOccurrences: 1 },
    areBlockadesRestrictedToChaos: true,
    blockadesInSinglePathChance: 0.5,
    blockadeStartBias: 0,
    nonAdjacentBlockadesBias: 0.6,
    guaranteeSafeStartLines: 3,
    towerVerticalShift: 0,
  },
  3: {
    name: "Hard",
    shift: 4,
    singlePathConstraints: { minLine: 3, maxOccurrences: 2, minOccurrences: 2 },
    areBlockadesRestrictedToChaos: true,
    blockadesInSinglePathChance: 0.9,
    blockadeStartBias: 0.7,
    nonAdjacentBlockadesBias: 0.3,
    guaranteeSafeStartLines: 2,
    towerVerticalShift: 1,
  },
  4: {
    name: "Insane",
    shift: 6,
    singlePathConstraints: { minLine: 1, maxOccurrences: 4, minOccurrences: 3 },
    areBlockadesRestrictedToChaos: false,
    blockadesInSinglePathChance: 1,
    blockadeStartBias: 1,
    nonAdjacentBlockadesBias: 0.1,
    guaranteeSafeStartLines: 0,
    towerVerticalShift: 2,
  },
};
